.autocompleteInput {
    background: var(--exwo-color-control-bar-bg);
    border: 1px solid var(--mantine-color-dark-3);
    border-radius: 8px;
}

.autocompleteInput:focus {
    border: 1px solid var(--mantine-color-primary-4);
}

.autocompleteOption {
    font-size: var(--mantine-font-size-xs);
}

.autocompleteOption:hover {
    background: var(--mantine-color-dark-5);
}

.autocompleteSection {
    stroke: var(--mantine-color-dark-2);
}

/* a background color #D5D6DA at 8%  and pressed is 16%  */
.clearButton:hover {
    background-color: color-mix(in srgb, var(--mantine-color-dark-1), transparent 92%);
    cursor: pointer;
}

.clearButton:active {
    background-color: color-mix(in srgb, var(--mantine-color-dark-1), transparent 84%);
}
